/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-12-16 19:39:20
 * @FilePath: \baishu_react_ui\src\components\BsyTableList\indexHTd.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import { createTooltip } from "../../utils/createTooltip";

class TableHTd extends Component {
  componentDidMount = () => {
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
  };

  componentWillUnmount() {
    this.hideTooltip();
  }

  render() {
    const { val } = this.props;
    return (
      <td
        className={val.key ? val.key : ""}
        style={{ width: val.width + "px", minWidth: val.width + "px" }}
      >
        <div className="cell">
          <span>{val.value}</span>
          {val.tooltip && (
            <div className="tip">
              <i
                data-tip={val.tooltip}
                className="icon-shixinhelp"
                data-place={"top"}
                onMouseEnter={(e) => {
                  this.showTooltip(e.currentTarget, val.tooltip, "bottom", 10);
                }}
                onMouseLeave={this.hideTooltip}
                data-type={window.mode}
                data-html={true}
                data-class="mytip"
              ></i>
            </div>
          )}
        </div>
      </td>
    );
  }
}

export default TableHTd;
